import { render, staticRenderFns } from "./ServiceRecord.vue?vue&type=template&id=1ef995d4&scoped=true"
import script from "./ServiceRecord.vue?vue&type=script&lang=js"
export * from "./ServiceRecord.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecord.vue?vue&type=style&index=0&id=1ef995d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef995d4",
  null
  
)

export default component.exports